import * as React from "react";
import { useDebounce } from "use-debounce";

const useRipple = (ref, color) => {
    const [ripples, setRipples] = React.useState([]);
    const _debounced = useDebounce(ripples, 200);
    React.useEffect(() => {
        if (ref.current) {
            const btn = ref.current;
            const clickHandler = (e) => {
                var rect = btn.getBoundingClientRect();
                var left = e.clientX - rect.left;
                var top = e.clientY - rect.top;
                const height = btn.clientHeight;
                const width = btn.clientWidth;
                const diameter = Math.max(width, height);
                setRipples([
                    ...ripples,
                    {
                        top: top - diameter / 2,
                        left: left - diameter / 2,
                        height: Math.max(width, height),
                        width: Math.max(width, height),
                    },
                ]);
            };

            btn.addEventListener("mousedown", clickHandler);
            return () => {
                btn.removeEventListener("mousedown", clickHandler);
            };
        }
    }, [ref, ripples]);

    React.useEffect(() => {
        if (_debounced.length) {
            setRipples([]);
        }
    }, [_debounced.length]);

    return ripples?.map((style, i) => {
        return (
            <span
                key={i}
                style={{
                    ...style,
                    position: "absolute",
                    backgroundColor: color,
                    opacity: "50%",
                    transform: "scale(0)",
                    animation: "ripple 800ms linear",
                    borderRadius: "50%",
                }}
            />
        );
    });
};

export default useRipple;
